import React from 'react';
import { Tooltip } from '@mui/material';
import InfoIconSolid from "assets/img/svg/svgComponents/InfoIconSolid";
import { endpoint } from "../../../../views/pages/manage/common/constant"
import { dropdownMapping, fetchAllPostPromisedData, fetchAllPromisedData, getDropdownLabelsFromSelectArray, updateRequest } from "../../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod"
import { downLoadFile } from "views/pages/manage/unAssigned/collectPayment/selectPaymentMode/components/common"
import moment from "moment"
import { approvalConfig } from "./config";

export const getDropdowns = async (isFirstTimeApiCallRequred=true) => {
  try {
const results = await Promise.allSettled([
  dropdownMapping(
    endpoint.businessArea.getAllActiveV2,
    "businessAreaDispValue",
    "id"
  ),

  ...(isFirstTimeApiCallRequred
    ? [
        dropdownMapping(
          endpoint.term.getAllActive,
          "termDispValue",
          "termDispValue"
        ),
        dropdownMapping(
          endpoint.businessArea.getCashierOfficeDetails,
          "businessAreaDispValue",
          "businessAreaDispValue"
        ),
        dropdownMapping(
          endpoint.courseCatelogMapping.getAllActiveCourseIds,
          "courseIds"
        )
      ]
    : [])
]);


    const [businessAreas, terms, cashierOffice, courseId] = results.map(r =>
      r.status === "fulfilled" ? r.value : []
    );

    return {
      businessAreas,
      terms,
      cashierOffice,
      courseId,
      paymentStatus: [],
    };
  } catch (e) {
    console.error("getDropdowns failed:", e);
    return {
      businessAreas: [],
      paymentModeType: [],
      terms: [],
      paymentStatus: [],
    };
  }
};

export const slipViewHandler = async (s3Key, setLoader) => {
  try {
    setLoader(true);
    await downLoadFile(false, s3Key)
  }
  catch (err) {
    console.error(err);
  }
  finally {
    setLoader(false)
  }
}

export const rejectionHandler = async (rejectRequest) => {
  const {
    id,
    approvalStatus,
    setUpdateStatusInfo,
    status,
    approvalAction,
    isRemarkMandatory,
    depositSlipNo,
    isUpdatedDetailRequired,
    userDetails
  } = rejectRequest || {}

  setUpdateStatusInfo({
    ...rejectRequest,
    approvalAction: approvalAction,
    dialogInfo: rejectRequest?.dialogInfo ?? { subHeading: "" },
    dropdown: null,
    id: null,
    depositSlipNo,
    status,
    approvalStatus,
    isRemarkMandatory: isRemarkMandatory || false,
    updatedOn: rejectRequest?.updatedOn,
    updatedBy: rejectRequest?.updatedBy,
    isUpdatedDetailRequired: isUpdatedDetailRequired || false,
    userDetails
  })
}

export const getApprovalPermissions = ({
  approvalConfigResponseDTOList = [],
  roleId,
  approvalRequest = {},
}) => {
  const { businessAreaValue,  cashierOffice } = approvalRequest;

  if (!roleId || !businessAreaValue || !cashierOffice) {
    return { isL1Approver: false, isL2Approver: false, isL3Approver: false };
  }

  // Match based on new fields: businessAreas & cashierOffices
  const matchedConfigs = approvalConfigResponseDTOList.filter(item =>
    Array.isArray(item?.businessAreas) &&
    item.businessAreas.includes(businessAreaValue?.value) &&
    Array.isArray(item?.cashierOffices) &&
    item.cashierOffices.includes(cashierOffice)
  );

  let l1 = false,
    l2 = false,
    l3 = false;

  for (const item of matchedConfigs) {
    for (const appr of item?.paymentManagementApprovalConfigDtoList ?? []) {
      // if (appr?.paymodeType !== paymodeType) continue;

      if (!l1 && Array.isArray(appr?.l1ApprovalRoles)) {
        l1 = appr.l1ApprovalRoles.includes(roleId);
      }
      if (!l2 && Array.isArray(appr?.l2ApprovalRoles)) {
        l2 = appr.l2ApprovalRoles.includes(roleId);
      }
      if (!l3 && Array.isArray(appr?.l3ApprovalRoles)) {
        l3 = appr.l3ApprovalRoles.includes(roleId);
      }

      if (l1 && l2 && l3) break;
    }
    if (l1 && l2 && l3) break;
  }

  return { isL1Approver: l1, isL2Approver: l2, isL3Approver: l3 };
};


export const mapApprovalPermissions = (list, dropdowns, roleId, approvalConfigs) => {
  const { businessAreas } = dropdowns;

  return list?.map(el => {
    const businessAreaValue =
      businessAreas?.find(bu => bu?.label === el?.businessAreaValue) ??
      el.businessAreaValue;

    const approvalRequest = {
      ...el,
      businessAreaValue,
    };

    return {
      ...approvalRequest,
      ...getApprovalPermissions({
        approvalConfigResponseDTOList: approvalConfigs,
        roleId,
        approvalRequest,
      }),
    };
  });
};

export const getDaysBetweenDates = (date1, date2) => {
  return Math.abs(
    moment(date2).startOf("day").diff(
      moment(date1).startOf("day"),
      "days"
    )
  );
}



export const submitApprovalAction = async (reqObj, type = 'cash') => {
  const req = {
    approvalAction: reqObj?.approvalAction,
    depositSlipId: reqObj?.depositSlipNo || null,
    remarks: reqObj?.remark,
    referenceNumber: reqObj?.referenceNumber || null,
    psid: reqObj?.psid || null,
    daysExtended: (reqObj?.oldChequeDate && reqObj?.newChequeDate) ? getDaysBetweenDates(reqObj?.oldChequeDate, reqObj?.newChequeDate) : null,
    // approvalStatus: 
    // refundReasonId: reqObj?.selectedReason,
    // beneficiaryName: reqObj?.beneficiaryName,
    // paymentAccountDetailsId: reqObj?.paymentModeAccountDetailId
  }
  return await fetchAllPostPromisedData(`${approvalConfig?.[type].endpoints.updateStatus}`, updateRequest(req))
}

export const searchCashDepositSlips = async ({
  pageNo = 0,
  pageSize = 10,
  filters,
  dropdowns,
  type = 'cash'
}) => {
  const businessArea = filters?.businessArea?.length ? filters?.businessArea : dropdowns?.businessAreas;
  const updatedFilters = {
    ...filters,
    startDate: filters?.startDate ? moment(filters?.startDate).startOf('day') : "",
    endDate: filters?.endDate ? moment(filters?.endDate).endOf('day') : "",
    term: filters?.term,
    businessArea
  }
  let req = updateRequest({ ...updatedFilters });
  req = {
    ...req,
    businessArea: getDropdownLabelsFromSelectArray(businessArea)
    // approvalStatusList : updatedStatusList[req.approvalStatus]
  }
  return fetchAllPostPromisedData(`${approvalConfig?.[type].endpoints.searchListing}?offset=${pageNo}&pageSize=${pageSize}`, req);
}

export const formattedDate = (timestamp) => moment(timestamp).format("DD/MM/YYYY");

export const getStatusChipInfo = (row) => {

  const { approvalStatus, remarks = "" } = row;


  switch (true) {

    case approvalStatus?.includes("REJECTED"): {
      return {
        text: (
          <span>
            Rejected
            <Tooltip title={remarks || "-"}>
              <span className='ml-2'><InfoIconSolid color={"#B32306"} /></span>
            </Tooltip>
          </span>
        ),
        bgColor: "#F9D9D7",
        textColor: "#B32306"
      }
    }

    case approvalStatus?.includes('PENDING'): {
      const isL1 = approvalStatus?.includes("L1");
      const isL2 = approvalStatus?.includes("L2");
      const text = `Pending at ${isL1 ? 'L1' : isL2 ? 'L2' : 'L3'}`;
      return {
        text: text,
        bgColor: "#FFEDC8",
        textColor: "#A17217"
      }

    }

    case approvalStatus?.includes('APPROVED'): {
      return {
        text: 'Approved',
        bgColor: "#BBE2CE",
        textColor: "#0B442D"
      }

    }

    case approvalStatus?.includes('SENT_CORRECTION'): {
      return {
        text: (
          <span>
            Sent For Correction
            <Tooltip title={remarks || "-"}>
              <span className='ml-2'><InfoIconSolid color={"#262626"} /></span>
            </Tooltip>
          </span>
        ),
        bgColor: "#F5F5F5",
        textColor: "#262626"
      }

    }


  }
}

export const getChequeExtensionHistory = async (referenceNumber) => {
  try {
    const req = await fetchAllPromisedData(`${endpoint.chequeManagement.dateExtension.audit}/${referenceNumber}`);
    return req;
  }
  catch (err) {
    console.error(err);
    return null;
  }
}



